import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=cd680c56"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"
import style0 from "./Compose.vue?vue&type=style&index=0&id=cd680c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports